/** @jsxImportSource @emotion/react */
import React from 'react'
import { isDesktop } from '../../utils'

import './Layout.css'
import { SuperGradientBackground, SuperLogo } from '@slite/components'
import classNames from 'classnames'
import { Helmet } from 'react-helmet'
import { css } from '@emotion/react'

export function SliteLogo() {
  const isDesktopApp = isDesktop()
  const LogoImage = React.useCallback(
    () => (
      <img
        src="https://assets.slite.com/logos/word-mark-space-grey.png"
        height="24"
        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        alt="slite"
      />
    ),
    []
  )

  return isDesktopApp ? (
    <LogoImage />
  ) : (
    <a href="/?redirect=no">
      <LogoImage />
    </a>
  )
}

type LayoutProps = {
  superEnabled: boolean
  children: React.ReactNode
}

export function Layout({ superEnabled, children }: LayoutProps) {
  return (
    <>
      <Helmet
        link={[
          {
            rel: 'icon',
            href: superEnabled
              ? 'https://storage.googleapis.com/slite-cdn/super-assets/favicon.ico?v=2'
              : 'https://assets.slite.com/logos/favicon.ico',
            type: 'image/x-icon',
          },
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '16x16',
            href: superEnabled
              ? 'https://storage.googleapis.com/slite-cdn/super-assets/favicon-16x16.png'
              : 'https://storage.googleapis.com/slite-cdn/slite-assets/favicon-16x16.png?v=2',
          },
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
            href: superEnabled
              ? 'https://storage.googleapis.com/slite-cdn/super-assets/favicon-32x32.png'
              : 'https://storage.googleapis.com/slite-cdn/slite-assets/favicon-32x32.png?v=2',
          },
          {
            rel: 'apple-touch-icon',
            type: 'image/png',
            href: superEnabled
              ? 'https://storage.googleapis.com/slite-cdn/super-assets/apple-touch-icon.png'
              : 'https://storage.googleapis.com/slite-cdn/slite-assets/apple-touch-icon.png?v=2',
          },
        ]}
      />
      <div
        className={classNames(
          superEnabled
            ? 'dark-mode background-super-space-dark position-relative'
            : 'background-moon-dust'
        )}
        css={
          superEnabled
            ? css({ '--font-family-title': 'var(--font-family-super-title)' })
            : undefined
        }
      >
        {superEnabled && (
          <div className="position-coverer flexbox flexbox-centered">
            <SuperGradientBackground type="messy-horizontal" width="100%" />
          </div>
        )}
        <div className="position-relative">
          <div className="desktop-drag-bar" />
          <div className="content-top-banner padding-40">
            {superEnabled ? (
              <a href="/?redirect=no">
                <SuperLogo
                  variant="wordmark"
                  height={24}
                  color="var(--shade-00)"
                />
              </a>
            ) : (
              <SliteLogo />
            )}
          </div>
          <div className="content-layout">{children}</div>
        </div>
      </div>
    </>
  )
}
